import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ApiService } from 'src/app/services/api.service';
import { UtilitiesService } from 'src/app/services/utilities.service';
import Swal from 'sweetalert2'
import { CommonService } from '../../services/common.service';

@Component({
    selector: 'app-details',
    templateUrl: './details.component.html',
    styleUrls: ['./details.component.css'],
    standalone: false
})
export class DetailsComponent implements OnInit {

  page_a = 1;
  pageSize_a = 5;
  page_b = 1;
  pageSize_b = 5;
  page_c = 1;
  pageSize_c = 5;
  page_d = 1;
  pageSize_d = 10;

  appointments: any[] = [];
  history: any[] = [];
  invoices: any[] = [];
  doctors: any[] = [];
  slots: any[] = [];
  doctor_slots: any[] = [];
  services: any[] = [];
  packages: any[] = [];
  packages_all: any[] = [];

  token: any;
  patient: any;

  appointment = {
    date: '',
    doctor_id: null,
    patient_id: null,
    active: false,
    notes: '',
    service: '',
    price: 0,
    amount_due: 0,
    period: 30,
    walkin: false,
    overbooked: false
  }

  package = {
    package_id: null,
    no_sessions: 0,
    session_price: 0,
    service_name: null,
    service_id: null,
    name: null
  }

  Swal = 'sweetalert2'
  user_id: any;

  schedual_id: any;
  appointment_id: any;

  files: any;
  constructor(public utility: UtilitiesService, private modalService: NgbModal, private api: ApiService, private route: ActivatedRoute, public datepipe: DatePipe, private router: Router, public common: CommonService) {
    this.utility.show = true;
    this.token = localStorage.getItem('access_token');
    this.user_id = localStorage.getItem('id');
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      let id = params['id'] != null ? params['id'] : null;
      this.appointment.patient_id = id;

      this.getPatient(id);
    });
  }

  open(content: any) {
    this.getDoctors();

    var date = new Date();
    var month = (date.getMonth() + 1).toString();
    var day = (date.getDate()).toString();

    if (+month < 10)
      month = '0' + month;

    if (+day < 10)
      day = '0' + day;

    this.appointment.date = date.getFullYear() + '-' + month + '-' + day;

    this.modalService.open(content);
  }

  getPatient(id: any) {
    this.utility.loading = true;
    const sub = this.api.get('patients/' + id, this.token).subscribe(
      async data => {

        let objects: any = {}
        objects = data;

        this.patient = objects;
      },
      async error => { }
    );
    sub.add(() => { this.getPatientPackges(id); })
  }

  getPatientAppointments(id: any) {
    const sub = this.api.get('appointments/patient/' + id, this.token).subscribe(
      async data => {
        let objects: any = {}
        objects = data;
        this.appointments = objects.appointments;
      },
      async error => { }
    );

    sub.add(() => { this.getPatientHistory(id); });
  }

  getPatientHistory(id: any) {
    const sub = this.api.get('appointments/patient/history/' + id, this.token).subscribe(
      async data => {
        let objects: any = {}
        objects = data;
        this.history = objects.appointments;
      },
      async error => { }
    );

    sub.add(() => { this.getPatientPackges(id) });
  }

  getPatientPackges(id: any) {
    const sub = this.api.get('package_patients/patient/' + id, this.token).subscribe(
      async data => {
        let objects: any = {}
        objects = data;
        this.packages = objects;
      },
      async error => { }
    );

    sub.add(() => { this.getPackages(); });
  }

  async getPackages() {
    const sub = this.api.get('packages/', this.token).subscribe(
      async data => {
        let objects: any = {}
        objects = data;
        this.packages_all = objects;
      },
      async error => { }
    );

    sub.add(() => { this.utility.loading = false; });
  }

  getDoctors() {
    let doctors = localStorage.getItem('doctors');

    if (doctors) {
      this.doctors = JSON.parse(doctors);
      this.getServices();
    }

    // const sub = this.api.get('employees/role/doctor', this.token).subscribe(
    //   async data => {
    //     let objects: any = {}
    //     objects = data;
    //     this.doctors = objects;
    //   },
    //   async error => { }
    // );
    // sub.add(() => { this.getServices(); });
  }

  getServices() {
    const sub = this.api.get('services/', this.token).subscribe(
      async data => {
        let objects: any = {}
        objects = data;
        this.services = objects;
      },
      async error => { }
    );
    sub.add(() => { });
  }

  getDoctorSlots() {
    if (this.appointment.doctor_id) {
      this.utility.loading = true;
      const sub = this.api.get('schedules/' + this.appointment.doctor_id, this.token).subscribe(
        async data => {
          let objects: any = {}
          objects = data;

          this.slots = objects.schedules;
          this.doctor_slots = this.slots;
        },
        async error => { }
      );
      sub.add(() => { this.utility.loading = false; });
    }
  }

  dateSelection(slots: any[]) {
    let select_date = this.datepipe.transform(this.appointment.date, 'yyyy-MM-dd');
    return slots.filter(i => this.datepipe.transform(i.date_time, 'yyyy-MM-dd') === select_date);
  }

  createAppointment(content: any) {
    const body = {
      date_time: this.appointment.date,
      period: this.appointment.period,
      active: true,
      doctor_id: this.appointment.doctor_id
    }

    const sub = this.api.post("schedules/", body, this.token).subscribe(
      async data => {
        let objects: any = {}
        objects = data;

        this.schedual_id = objects.id;
        if (this.schedual_id) {
          let service_name = this.services.find(i => i.id === this.appointment.service);
          const body = {
            date: this.appointment.date,
            period: this.appointment.period,
            notes: this.appointment.notes,
            service: this.package.service_name ? this.package.service_name : ' - ',
            service_id: this.appointment.service,
            patient_id: this.appointment.patient_id,
            doctor_id: this.appointment.doctor_id,
            slot_id: this.schedual_id,
            user_id: this.user_id,
            amount_due: this.appointment.amount_due,
            walkin: this.appointment.walkin,
            overbooked: this.appointment.overbooked
          }

          const sub = this.api.post("appointments/", body, this.token).subscribe(
            async data => {
              // redirect to appointment details page...
              let appointment: any = data;
              this.appointment_id = appointment[0][0].id;
              // this.goToDetails(appointment[0][0]);

              // select package ...
              localStorage.removeItem('appointment');
              localStorage.setItem('appointment', JSON.stringify(appointment[0][0]));
              // check if the patient has package on this service... 
              // if yes pop-up
              if (this.common.appointment.has_pacakge || this.common.appointment.package == null) {
                Swal.fire({
                  title: 'Success!',
                  text: 'Appointment Added Successfuly!',
                  icon: 'success',
                  confirmButtonText: 'Cool'
                });
                this.modalService.dismissAll();
              }
              else if (!this.common.appointment.has_pacakge || this.common.appointment.package != null)
                this.modalService.open(content);
            },
            async error => {
              Swal.fire({
                title: 'Error!',
                text: 'Error making the appointment :(',
                icon: 'error',
                confirmButtonText: 'Ok'
              });

              this.common.deleteSchedual(this.schedual_id);
            }
          );

          sub.add(() => {
            //this.modalService.dismissAll();
          });
        }
      },
      async error => {
        Swal.fire({
          title: 'Error!',
          text: 'Something went wrong!',
          icon: 'error',
          confirmButtonText: 'Ok'
        });
      }
    );
  }

  getPrice() {
    let service = this.services.find(i => i.id === this.appointment.service);
    this.appointment.price = service?.price;
    this.appointment.amount_due = service ? service.price : 0;
    this.package.service_name = service.name;

    this.common.checkPackagesServices(this.appointment.patient_id, service.id);
  }

  goToDetails(appointment: any) {
    appointment.patient = this.patient;

    localStorage.removeItem('appointment');
    localStorage.setItem('appointment', JSON.stringify(appointment));

    this.router.navigate(['view_details']);
  }

  fileChange(event: any) {
    let fileList: FileList = event.target.files;
    this.files = fileList;
  }

  submit() {
    let formData: FormData = new FormData();
    if (this.files && this.files.length > 0) {
      for (let file of this.files) {
        formData.append('file', file, file.name);
      }

      this.api.upload("patients/upload/" + this.patient.id + '/1', formData).subscribe(
        async data => {
          Swal.fire({
            title: 'Success!',
            text: 'files uploaded Successfuly!',
            icon: 'success',
            confirmButtonText: 'Cool'
          })

          this.getPatient(this.appointment.patient_id); 
          this.modalService.dismissAll();
        },
        async error => {
          Swal.fire({
            title: 'Error!',
            text: 'Error cannot connect!',
            icon: 'error',
            confirmButtonText: 'Ok'
          });
        }
      );
    }
    else {
      Swal.fire({
        title: 'Warning!',
        text: 'No Files Selected!',
        icon: 'error',
        confirmButtonText: 'Ok'
      });
    }
  }

  onChangePackage() {
    let package_ = this.packages_all.find(i => i.id === this.package.package_id);
    this.package.no_sessions = package_.no_sessions;
    this.package.name = package_.name;
    this.package.service_id = package_.service_id;
    this.package.session_price = package_.session_price;
  }

  OnSumbitPackage() {
    if (this.package.package_id) {
      let body = {
        package_id: this.package.package_id,
        patient_id: this.appointment.patient_id,
        full_price: (+this.appointment.amount_due * +this.package.no_sessions),
        session_price: this.appointment.amount_due,
        service_name: this.package.service_name,
        service_id: this.package.service_id,
        paied_amount: 0,
        no_sessions: this.package.no_sessions,
        no_sessions_left: this.package.no_sessions,
        no_sessions_took: 0
      }

      this.api.post("package_patients/", body, this.token).subscribe(
        async data => {
          Swal.fire({
            title: 'Success!',
            text: `Appointment with ${this.package.name} Package Added Successfuly!`,
            icon: 'success',
            confirmButtonText: 'Cool'
          })
        },
        async error => {
          Swal.fire({
            title: 'Error!',
            text: 'Something went wrong!',
            icon: 'error',
            confirmButtonText: 'Ok'
          });

          this.common.deleteSchAppointment(this.schedual_id, this.appointment_id);
        }
      );

    } else {
      Swal.fire({
        title: 'Success!',
        text: 'Appointment Added Successfuly!',
        icon: 'success',
        confirmButtonText: 'Cool'
      })
    }

    this.modalService.dismissAll();
  }

  getFileName(url: string): string {
    if (!url) return '';
    return decodeURIComponent(url.split('/').pop() || '');
  }

  onDelete(id: any) {
    if (confirm("Are sure you want to delete the file?")) {
      const sub = this.api.delete('patients/upload/' + id, this.token).subscribe(
        async data => {
          Swal.fire({
            title: 'Success!',
            text: 'Deleted Successfuly!',
            icon: 'success',
            confirmButtonText: 'Cool'
          })
        },
        async error => {
          Swal.fire({
            title: 'Error!',
            text: 'Something went wrong!',
            icon: 'error',
            confirmButtonText: 'Ok'
          });
        }
      );

      sub.add(() => { this.getPatient(this.appointment.patient_id); });
    }
  }
}
